import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

/** Rectangular skeleton card that matches the product card dimensions */
function ProductCardSkeleton() {
  return (
    <Box
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        boxShadow: '0 1px 4px rgba(0,0,0,.07)',
      }}
    >
      <Skeleton variant="rectangular" width="100%" height={200} sx={{ bgcolor: 'grey.100' }} />
      <Box sx={{ p: 1.5 }}>
        <Skeleton variant="text" width="70%" height={18} />
        <Skeleton variant="text" width="45%" height={14} sx={{ mt: 0.5 }} />
        <Skeleton variant="text" width="55%" height={22} sx={{ mt: 1 }} />
      </Box>
    </Box>
  );
}

/** Skeleton grid — renders n placeholder cards */
export function CatalogGridSkeleton({ count = 8 }) {
  return (
    <Grid container spacing={1.5}>
      {Array.from({ length: count }).map((_, i) => (
        <Grid item xs={6} sm={4} md={3} key={i}>
          <ProductCardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}

/** Skeleton for the product detail bottom sheet */
export function CatalogDetalleSkeleton() {
  return (
    <Box sx={{ p: 2.5 }}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={{ xs: 'min(52vh, 420px)', sm: 360 }}
        sx={{ bgcolor: 'grey.100', mb: 2 }}
      />
      <Skeleton variant="text" width="80%" height={28} />
      <Skeleton variant="text" width="50%" height={20} sx={{ mt: 0.5 }} />
      <Skeleton variant="text" width="35%" height={32} sx={{ mt: 1 }} />
      <Skeleton variant="text" width="100%" height={16} sx={{ mt: 2 }} />
      <Skeleton variant="text" width="90%"  height={16} sx={{ mt: 0.5 }} />
    </Box>
  );
}
